import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SepaMandate } from '../../models/sepa-mandates';
import { ListItemRendererComponent } from 'gung-list';
import { CommonModalService, DateUtilService } from 'gung-common';
import { CustomerDocumentsService } from '../../services/customer-documents/customer-documents.service';
import { SepaMandatesService } from '../../services/sepa-mandates/sepa-mandates.service';

@Component({
  selector: 'lib-sepa-mandates-list-view',
  standalone: false,
  templateUrl: './sepa-mandates-list-view.component.html',
  styleUrl: './sepa-mandates-list-view.component.scss'
})
export class SepaMandatesListViewComponent extends ListItemRendererComponent<SepaMandate[]> {
  public dateUtilService = inject(DateUtilService);
  protected customerDocumentsService = inject(CustomerDocumentsService);
  protected sepaMandatesService = inject(SepaMandatesService);
  protected commonModalService = inject(CommonModalService);
  protected translateService = inject(TranslateService);

  downloadMandate(mandateId: string): void {
    const relationId = `sepa-direct-debit_mandate:${mandateId}`;

    this.customerDocumentsService.getDocuments(relationId).subscribe(documents => {
      if (documents?.length) {
        this.customerDocumentsService.downloadDocument(documents[0]);
      }
    });
  }

  delete(mandateId: string): void {
    this.commonModalService
      .openConfirmYesNoModal(
        this.translateService.instant('DELETE_MANDATE'),
        this.translateService.instant('DELETE_MANDATE_CONFIRMATION')
      )
      .then(() => {
        this.sepaMandatesService.deleteSepaMandate(mandateId).subscribe();
      })
      .catch(() => {});
  }
}
